import {columnResizing, tableEditing} from "prosemirror-tables";
import {inputRules} from "prosemirror-inputrules";
import {createListPlugins, listInputRules} from "prosemirror-flat-list";
import {authorPlugin} from "../authorPlugin";
import {blockIdPlugin} from "../blockIdPlugin";
import {classificationFloorSyncPlugin} from "../classificationFloorSyncPlugin";
import {classificationGutterPlugin} from "../classificationGutterPlugin";
import {floatingMenuPlugin} from "../floatingMenuPlugin";
import {marginMarkersPlugin} from "../marginMarkersPlugin";
import {metaMarksPlugin} from "../metaMarksPlugin";
import {pasteLinkPlugin} from "../pasteLinkPlugin";
import {referenceCitationPlugin} from "../referenceCitation";
import {slashMenuPlugin} from "../slashMenuPlugin";
import {trailingParagraphPlugin} from "../trailingParagraphPlugin";
import {selectionStatePlugin} from "./selectionStatePlugin";
import {createImageToolbarPlugin} from "../imageToolbarPlugin";
import {createTableFloatingMenuPlugin} from "../tableFloatingMenuPlugin";

export function createCorePluginBundle({
    user,
    snippetDrop,
    yReferenceMarks,
    ydoc,
    classificationMenu,
    documentId,
    yDocMeta,
    editorMode = 'full',
    schema,
}) {
    const plugins = [];
    const basic = editorMode === 'basic';

    if (user) {
        plugins.push(authorPlugin(user));
    }

    plugins.push(blockIdPlugin());

    if (!basic) {
        plugins.push(
            metaMarksPlugin(),
            referenceCitationPlugin({reportId: snippetDrop?.reportId, yReferenceMarks}),
            marginMarkersPlugin({reportId: snippetDrop?.reportId}),
            classificationFloorSyncPlugin({documentId, yReferenceMarks}),
            floatingMenuPlugin(),
            createImageToolbarPlugin(),
        );
    }

    plugins.push(
        pasteLinkPlugin(),
        slashMenuPlugin({user}),
        selectionStatePlugin(),
        classificationGutterPlugin({
            openClassificationMenu: classificationMenu?.openMenu,
            documentId,
            yDocMeta,
            ydoc,
        }),
        trailingParagraphPlugin(),
        columnResizing(),
        tableEditing(),
        createTableFloatingMenuPlugin(),
    );

    // Flat list plugins (rendering, event handling, clipboard serialisation)
    if (schema) {
        plugins.push(...createListPlugins({schema}));
    }

    // Input rules for flat lists: "- " → bullet, "1. " → ordered, "[] " → task
    plugins.push(inputRules({rules: listInputRules}));

    return plugins;
}
